import React from 'react';
import {Stack} from '@mui/material';
import {Outlet} from 'react-router';

const KnowledgeBasePage = () => {
    return (
        <Stack height="100%" overflow="hidden">
            <Outlet/>
        </Stack>
    );
};

export default KnowledgeBasePage;

